import * as React from 'react';
import { IPageWrapperProps, PageWrapper } from 'components/widgets/PageWrapper';
import {PageEnum} from "components/nav/PageEnums";

export interface IStaticPageWrapperProps extends IPageWrapperProps {
	backgroundImage?:string;
	backgroundSize?:string;
	backgroundPosition?:string;
	backgroundRepeat?:string;
	nav:any;
	children?:any;
	pageEnum:PageEnum;
}

export const centeredMessageStyle:any = {
	position:'absolute',
	top:'50%',
	left:'50%',
	transform:' translate(-50%, -50%)',
	maxWidth:'500px', 
	backgroundColor:'rgba(255,255,255,.80)',
	margin:'auto', 
	boxShadow:'0px 2px 4px 0px rgba(0,0,0,0.25)',
	borderRadius:'4px',
	width: '90%'
}

export const StaticPageWrapper = (props:IStaticPageWrapperProps) => {
	let contentStyle:any = { };
	if(props.backgroundImage) {
		contentStyle.backgroundImage = 'url("' + props.backgroundImage + '")';
		contentStyle.backgroundRepeat = (props.backgroundRepeat?props.backgroundRepeat:'no-repeat');
		contentStyle.backgroundPosition = (props.backgroundPosition?props.backgroundPosition:'left -48px');
		contentStyle.backgroundSize = (props.backgroundSize?props.backgroundSize:'contain');
	}
	return (
		<>
			{props.nav}
			<PageWrapper contentStyle={contentStyle} static={true} {...props}  />
		</>
	);
}
